import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Toaster } from 'react-hot-toast';
import './App.css';

// Componentes
import Header from './components/Header';
import ProductGrid from './components/ProductGrid';
import ProductDetail from './components/ProductDetail';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import SearchResultsPage from './pages/SearchResultsPage';
import AvisoLegal from './pages/AvisoLegal';
import WhatsAppButton from './components/WhatsAppButton';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';

function App() {
  const [showCart, setShowCart] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <div className="App min-h-screen bg-gradient-to-br from-red-50 via-white to-red-100 stadium-atmosphere">
            <Toaster position="top-right" />
            
            {/* Fondo animado temático de fútbol */}
            <div className="fixed inset-0 overflow-hidden pointer-events-none">
              {/* Efecto de estadio */}
              <motion.div
                className="absolute -top-1/2 -left-1/2 w-full h-full bg-gradient-to-br from-red-600/10 via-red-300/5 to-white/10 rounded-full"
                animate={{
                  rotate: 360,
                  scale: [1, 1.1, 1],
                }}
                transition={{
                  duration: 25,
                  repeat: Infinity,
                  ease: "linear"
                }}
              />
              <motion.div
                className="absolute -bottom-1/2 -right-1/2 w-full h-full bg-gradient-to-tl from-red-700/10 via-red-400/5 to-white/10 rounded-full"
                animate={{
                  rotate: -360,
                  scale: [1, 1.2, 1],
                }}
                transition={{
                  duration: 30,
                  repeat: Infinity,
                  ease: "linear"
                }}
              />
              
              {/* Elementos flotantes de fútbol */}
              <motion.div
                className="absolute top-1/4 left-1/4 w-8 h-8 bg-red-600 rounded-full opacity-20"
                animate={{
                  y: [0, -20, 0],
                  x: [0, 10, 0],
                  rotate: [0, 180, 360],
                }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              />
              <motion.div
                className="absolute bottom-1/3 right-1/3 w-6 h-6 bg-white rounded-full opacity-30"
                animate={{
                  y: [0, -15, 0],
                  x: [0, -15, 0],
                  rotate: [0, -180, -360],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              />
              <motion.div
                className="absolute top-2/3 left-2/3 w-4 h-4 bg-red-500 rounded-full opacity-25"
                animate={{
                  y: [0, -25, 0],
                  x: [0, 20, 0],
                  scale: [1, 1.2, 1],
                }}
                transition={{
                  duration: 6,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              />
            </div>

            <Routes>
              <Route path="/" element={
                <div className="relative z-10">
                  <Header onCartClick={() => setShowCart(true)} />
                  <main className="container mx-auto px-4 py-8">
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6 }}
                    >
                      <ProductGrid onProductSelect={setSelectedProduct} />
                    </motion.div>
                  </main>
                </div>
              } />
              
              <Route path="/product/:id" element={
                <div className="relative z-10">
                  <Header onCartClick={() => setShowCart(true)} />
                  <main className="container mx-auto px-4 py-8">
                    <ProductDetail />
                  </main>
                </div>
              } />

              <Route path="/search" element={
                <div className="relative z-10">
                  <Header onCartClick={() => setShowCart(true)} />
                  <main>
                    <SearchResultsPage />
                  </main>
                </div>
              } />

              <Route path="/aviso-legal" element={
                <div className="relative z-10">
                  <main>
                    <AvisoLegal />
                  </main>
                </div>
              } />
              
              <Route path="/checkout" element={
                <div className="relative z-10">
                  <Header onCartClick={() => setShowCart(true)} />
                  <main className="container mx-auto px-4 py-8">
                    <Checkout />
                  </main>
                </div>
              } />
              
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            </Routes>

            {/* Cart Sidebar */}
            <Cart isOpen={showCart} onClose={() => setShowCart(false)} />
            
            {/* WhatsApp Button */}
            <WhatsAppButton />
          </div>

        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
